export default __webpack_public_path__ + "static/media/stage-favicon.c4975ffb.svg";